/* TKS Wishlist — shared across all product templates */
(function(){
  var WL_KEY = 'tks_wishlist';

  function getList(){
    try { return JSON.parse(localStorage.getItem(WL_KEY)) || []; } catch(e){ return []; }
  }

  function saveList(list){
    try { localStorage.setItem(WL_KEY, JSON.stringify(list)); } catch(e){}
  }

  function isInList(handle){
    return getList().some(function(p){ return p.handle === handle; });
  }

  function addItem(data){
    var list = getList();
    if(!list.some(function(p){ return p.handle === data.handle; })){
      list.unshift(data);
      saveList(list);
    }
  }

  function removeItem(handle){
    saveList(getList().filter(function(p){ return p.handle !== handle; }));
  }

  /* Bottom-nav wishlist count badge */
  function updateNavCount(){
    var link = document.querySelector('.tks-global-nav a[href="/pages/wishlist"]');
    if(!link) return;
    var badge = link.querySelector('.tks-nav-wish-count');
    if(!badge){
      var svg = link.querySelector('svg');
      if(!svg) return;
      var ico = document.createElement('span');
      ico.className = 'tks-nav-ico';
      svg.parentNode.insertBefore(ico, svg);
      ico.appendChild(svg);
      badge = document.createElement('span');
      badge.className = 'tks-nav-cart-count tks-nav-wish-count';
      badge.hidden = true;
      ico.appendChild(badge);
    }
    var n = getList().length;
    if(n > 0){ badge.textContent = n; badge.hidden = false; }
    else { badge.hidden = true; }
  }
  window.tksUpdateWishCount = updateNavCount;

  /* Animate the button after tap */
  function animateBtn(btn, added){
    if(!btn) return;
    btn.style.background = added ? '#fef3dc' : '';
    btn.style.borderColor = added ? '#c8860a' : '';
    btn.style.color = added ? '#c8860a' : '';
    var svg = btn.querySelector('svg');
    if(svg) svg.setAttribute('fill', added ? '#c8860a' : 'none');
    btn.querySelector('span') && (btn.querySelector('span').textContent = added ? 'Saved to wishlist ♥' : 'Save to wishlist');
    /* Show a small toast */
    var toast = document.createElement('div');
    toast.textContent = added ? '♥ Saved to wishlist' : 'Removed from wishlist';
    toast.style.cssText = 'position:fixed;bottom:80px;left:50%;transform:translateX(-50%);background:#4a3000;color:#fffdf7;padding:10px 20px;border-radius:20px;font-size:13px;z-index:99999;pointer-events:none;transition:opacity 0.4s;';
    document.body.appendChild(toast);
    setTimeout(function(){ toast.style.opacity='0'; }, 1800);
    setTimeout(function(){ toast.parentNode && toast.parentNode.removeChild(toast); }, 2300);
  }

  /* Called by each product page's wishlist button. Reads product data from data-* attributes (robust against money-filter HTML / quotes). */
  window.tksToggleWishlist = function(btn){
    if(!btn) return;
    var d = btn.dataset;
    var handle = d.handle;
    if(isInList(handle)){
      removeItem(handle);
      animateBtn(btn, false);
    } else {
      addItem({ handle: handle, title: d.title, price: d.price, img: d.img, url: d.url });
      animateBtn(btn, true);
    }
    updateNavCount();
  };

  /* On page load: restore button state + nav count */
  function init(){
    updateNavCount();
    var btn = document.getElementById('tks-wish-btn');
    if(!btn) return;
    var handle = btn.dataset.handle;
    if(handle && isInList(handle)){
      animateBtn(btn, true);
    }
  }
  if(document.readyState !== 'loading'){ init(); }
  else { document.addEventListener('DOMContentLoaded', init); }
})();
